import { Box } from '@mui/material';

const FallbackError = () => {
  return <Box>An error has occurred</Box>;
};

export default FallbackError;
